import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const ArrowDownIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props}>
      <path
        className={`icon--${props.color}`}
        d="M12 16.7928C11.8091 16.7926 11.6261 16.7167 11.4912 16.5816L3.34561 8.436C3.21843 8.29951 3.1492 8.11899 3.15249 7.93246C3.15578 7.74593 3.23134 7.56796 3.36326 7.43604C3.49517 7.30413 3.67314 7.22856 3.85967 7.22527C4.0462 7.22198 4.22673 7.29122 4.36322 7.4184L11.5752 14.6304C11.631 14.6863 11.6972 14.7306 11.7701 14.7608C11.843 14.7911 11.9211 14.8067 12 14.8067C12.0789 14.8067 12.1571 14.7911 12.23 14.7608C12.3029 14.7306 12.3691 14.6863 12.4248 14.6304L19.6368 7.4184C19.7733 7.29122 19.9538 7.22198 20.1404 7.22527C20.3269 7.22856 20.5049 7.30413 20.6368 7.43604C20.7687 7.56796 20.8443 7.74593 20.8476 7.93246C20.8508 8.11899 20.7816 8.29951 20.6544 8.436L12.5088 16.5816C12.3739 16.7167 12.1909 16.7926 12 16.7928Z"
      />
    </IconSvgWrapper>
  );
};

export default ArrowDownIcon;
